<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { PurchasableCoupon } from "@core/schema/PurchasableCoupon.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { selectedCurrency } from "../../state/selectedCurrency.svelte.js";
	import PurchasableCouponCard from "./PurchasableCouponCard.svelte";
	import translations from "./PurchasableCouponListingGrid.translations.json" with { type: "json" };

	const { purchasableCoupons }: { purchasableCoupons: PurchasableCoupon[] } = $props();
	const { tenant } = getGlobalTemplateProps();
	const currency = $derived(selectedCurrency.current ?? tenant.defaultCurrency);
	const visiblePurchasableCoupons = $derived(purchasableCoupons.filter((coupon) => coupon.currency === currency));
	const translate = getTranslate(translations);
</script>

<div class="grid-container full-width [--container-gap:1rem] gap-y-20 b2c-listing pb-20">
	{#each visiblePurchasableCoupons as purchasableCoupon (purchasableCoupon.id)}
		<PurchasableCouponCard
			{purchasableCoupon}
			class="mx-auto w-full max-w-100 md:max-w-none md:min-w-78 xl:w-[min(calc(25vw-var(--container-gap)*2),var(--spacing)*81.5)] xl:min-w-0 2xl:w-full product-card"
		/>
	{:else}
		<div class="text-fcrdarkgray col-span-full text-center my-5">
			<Formatted text={translate("noCoupons")} />
		</div>
	{/each}
</div>
